
import React, { Component } from 'react';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';

import { DateDisplay } from 'core/Display';
import TableSlots from './TableSlots';
import styled from 'styled-components';
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import {NavLink} from "react-router-dom";


const StyledTableRow = styled(TableRow)`
  &:hover {
    background: #f8f8f8;
  }

  td {
    padding: 6px 10px;
    vertical-align: top;
  }
`;

const Bundle = styled.div`
  display: grid;
  gap: 1px;
  min-width: 200px;
  font-size: 14px;
  line-height: 1.25;
`;

const BundleLine = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
`;

const BundleText = styled.div`
  min-width: 0;
`;

const ScheduleLink = styled(NavLink)`
  font-size: 13px;
  color: #2F80ED;
  margin-top: 2px;
`;


class SearchPhraseButton extends Component {

  render() {
    const { value, onChange } = this.props;
    return (
      <IconButton
        size={'small'}
        onClick={() => onChange(value)}
        style={{padding: 2}}
      >
        <SearchIcon style={{fontSize: 16}} />
      </IconButton>
    )
  }
}


function vehicleLine(vehicle) {
  if (!vehicle) {
    return null;
  }
  const typeLabel = vehicle.label || [vehicle.brand, vehicle.model].filter(Boolean).join(' ');
  return [vehicle.number, typeLabel, vehicle.year ? `(${vehicle.year})` : null].filter(Boolean).join(' ');
}


export class TimetableListTable extends Component {
  render() {
    const { items, dates, loading, onChangeSearchValue, previewId, onPreview, fromPath = '/timetable' } = this.props;

    return (
      <React.Fragment>
        <TableHead>
          <TableRow>
            <TableCell component="th" scope="row" className={'w-10 hide-on-mobile'}>#</TableCell>
            <TableCell component="th" scope="row" className={'w-280'}>Связка</TableCell>
            {dates.map(date =>
              <TableCell
                key={date}
                component="th"
                scope="row"
              >
                <DateDisplay value={date} format={'DD.MM'} />
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading && (
            <TableRow>
              <TableCell colSpan={2 + dates.length}>
                <CircularProgress />
              </TableCell>
            </TableRow>
          )}
          {items.map((item, index) => {
            const info = item.info;
            const tractorLine = vehicleLine(info.tractor_unit);
            const trailerLine = vehicleLine(info.semi_trailer);
            return (
              <StyledTableRow
                key={info.id}
              >
                <TableCell className={'hide-on-mobile'}>
                  {index + 1}
                </TableCell>
                <TableCell>
                  <Bundle>
                    <BundleLine>
                      <BundleText>
                        {tractorLine || '—'}
                      </BundleText>
                      {info.tractor_unit && (
                        <SearchPhraseButton value={info.tractor_unit.number} onChange={onChangeSearchValue} />
                      )}
                    </BundleLine>
                    <BundleLine>
                      <BundleText>
                        {info.driver ? info.driver.short_name : '—'}
                      </BundleText>
                      {info.driver && (
                        <SearchPhraseButton value={info.driver.last_name} onChange={onChangeSearchValue} />
                      )}
                    </BundleLine>
                    <BundleLine>
                      <BundleText>
                        {trailerLine || '—'}
                      </BundleText>
                      {info.semi_trailer && (
                        <SearchPhraseButton value={info.semi_trailer.number} onChange={onChangeSearchValue} />
                      )}
                    </BundleLine>
                    {info.schedule && (
                      <ScheduleLink
                        to={{
                          pathname: `/schedule/${info.schedule}`,
                          state: { from: fromPath }
                        }}
                      >
                        Связка #{info.schedule}
                      </ScheduleLink>
                    )}
                  </Bundle>
                </TableCell>
                {dates.map(date =>
                  <TableCell key={date} className={'full-row-mobile'} style={{verticalAlign: 'top'}}>
                    <TableSlots
                      info={info}
                      items={item['dates'][date]}
                      previewId={previewId}
                      onPreview={onPreview}
                    />
                  </TableCell>
                )}
              </StyledTableRow>
            )
          })}
          {(!loading && items.length === 0) && (
            <TableRow>
              <TableCell colSpan={2 + dates.length}>Ничего не найдено</TableCell>
            </TableRow>
          )}
        </TableBody>
      </React.Fragment>
    )
  }
}
